"use client";

import { usePathname } from "next/navigation";

import { MarketingFooter } from "@/components/marketing/MarketingFooter";
import { usePlatformAuth } from "@/hooks/use-platform-auth";
import { shouldShowMarketingFooter } from "@/lib/platform/chrome-policy";
import { cn } from "@/lib/utils";

type ChromeFooterProps = {
  className?: string;
};

/**
 * Renders the shared marketing footer only when platform chrome policy allows it.
 */
export function ChromeFooter({ className }: ChromeFooterProps) {
  const pathname = usePathname();
  const { isAuthenticated } = usePlatformAuth();

  if (!shouldShowMarketingFooter(pathname, isAuthenticated)) {
    return null;
  }

  return <MarketingFooter className={className} />;
}
